import { SvgIconTypeMap, SxProps, Theme } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "left" | "right" | "center";
  leftIcon?: OverridableComponent<SvgIconTypeMap<"svg">>;
  rightIcon?: OverridableComponent<SvgIconTypeMap<"svg">>;
  format?: (val: number | string) => string;
  sx?: SxProps<Theme>;
}


export const COLUMNS: readonly Column[] = [
  {
    id: "tripId",
    label: "Trip ID",
    minWidth: 100,
    align: "center",
  },
  {
    id: "title",
    label: "Trip Title",
    minWidth: 150,
    align: "center",
  },
  { id: "intro", label: "Trip Intro", minWidth: 200, align: "center" },
  { id: "group", label: "Group Type", minWidth: 100, align: "center" },
  { id: "tripType", label: "Trip Type", minWidth: 100, align: "center" },
  { id: "slotCount", label: "Slots Count", minWidth: 100, align: "center" },
  {
    id: "tripApprovalStatus",
    label: "Approval Status",
    minWidth: 100,
    align: "center",
  },
  {
    id: "updatedAt",
    label: "Updated at",
    minWidth: 200,
    align: "center"
  },
];

export interface Faq {
  id: number;
  question: string;
  answer: string;
}

export interface DescriptionSection {
  id: number;
  heading: string;
  subHeading: string;
  description: string;
}

export interface Location {
  destination: {
    country: string;
    state: string;
    district: string;
    airport?: string; // international only (auto-selected for start/end)
  }[];
  startLoc: {
    country: string;
    state: string;
    district: string;
    airport?: string; // international only (auto-selected for start/end)
  }[];
  endLoc: {
    country: string;
    state: string;
    district: string;
    airport?: string; // international only (auto-selected for start/end)
  }[];
}

export interface Video {
  fileName: string;
  mimetype: string;
  preview: string;
}

export interface InclusionItem {
  id: number;
  label: string;
  description: string;
}

export interface TripFormValues {
  title: string;
  intro: string;
  merchantId: string;
  tripScope: string; // "domestic" | "international"
  location: Location;
  minimumAge: number;
  maximumAge: number;
  group: string;
  tripType: string;
  faq: Faq[];
  descriptionSections: DescriptionSection[];
  tripApprovalStatus: string;
  comments: string;
  slotCount?: number;
  nights: number;
  days: number;
  stayDetails?: {
    id: string;
    sameAs?: string;
    accomodationType: string;
    hotelName: string;
    district: string;
    state: string;
    amities: string[];
    hotelIntro: string;
    hotelImage: Image[],
  }[];
  noStayDetails?: boolean;
  youtube: Video[];
  inclusion: InclusionItem[];
  weekend:boolean;
  exclusion:string;
  thingsToCarry:string;
}

export interface imageData {
  cover: {
    fileName: string;
    preview: string;
    mimetype: string;
  };
  tripImages: {
    fileName: string;
    preview: string;
    mimetype: string;
  }[];
}

export interface Trips {
  id: string;
  merchantId: string;
  merchantName: string;
  companyName: string;
  searchId: string;
  searchIdKey: string;
  title: string;
  intro: string;
  minimumAge: number;
  maximumAge: number;
  group: string;
  tripType: string;
  tripScope: string; // "domestic" | "international"
  tripApprovalStatus: string;
  status: string;
  comments: string;
  location: Location;
  faq: Faq[];
  descriptionSections: DescriptionSection[];
  createdAt: string;
  updatedAt: string;
  slotCount?: number;
  images?: imageData;
  nights: number;
  days: number;
  stayDetails?: {
    id: string;
    sameAs?: string;
    accomodationType: string;
    hotelName: string;
    district: string;
    state: string;
    amities: string[];
    hotelIntro: string;
    hotelImage: Image[],
  }[];
  noStayDetails?: boolean;
  youtube : Video[]; 
  inclusion: InclusionItem[];
  exclusion:string;
  weekend:boolean;
  thingsToCarry:string;
}

export interface TierType {
  id: number;
  status: "ACTIVE" | "INACTIVE";
  name: string;
  price: string;
  seatAllocation: string;
  moq:string;
  createdAt: string;
  updatedAt: string;
  isEdited: boolean;
  isNew: boolean,
  newVersion: TierType | null,
  initialSeats?: string
}

interface Image {
  file?: Blob | MediaSource;
  preview: string;
  fileName?: string;
  mimetype?: string;
}

export interface SlotsFormValues {
  id?: string;
  merchantName?: string;
  tripId: string;
  tripId_display?: string;
  triptitle?: string;
  hostId: string;
  hostDetails: {
    name: string;
    approvalStatus: string;
    mobileNumber: string;
  }[],
  merchantId: string;
  pickupLocation?: string[];
  dropLocation?: string[],
  seats: string;
  slotTiers: TierType[];
  status?: string;
  startDate: string;
  endDate: string;
  searchIdKey?: string;
  searchId?: string;
  hostApprovalStatus: string;
  slotApprovalStatus: string;
  createdAt?: string;
  startDateSearch?: string;
  endDateSearch?: string;
  initialTotalSeats?: string;
  groupSize?: string;
}
